import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

const addTranslationKey = async (lng, ns, key, context) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/locales/add/${lng}/${ns}`,
      {
        key,
        context,
      }
    );

  } catch (error) {
    console.error("Error adding translation:", error);
  }
};

export default function useTranslator() {
  const { t } = useTranslation();

  const _t = (key, context = "", namespace = "translation") => {
    const translation = t(key, { ns: namespace });

    // Check if the translation is missing (i.e., fallback to the default key itself).
    if (translation === key && namespace == "translation") {
      addTranslationKey("en-us", namespace, key, context);
    }

    return translation;
  };

  return {
    _t,
  };
}
